import { Subtitle } from "./video-player-subtitles.interface";

export const progressInRange = (progress: number, subtitle?: Subtitle): boolean =>
	!!subtitle && progress >= subtitle.startTimeInSec && progress < subtitle.endTimeInSec;
